import { selectRouteLeavingConfigs } from 'app/settings/selectors';
import { useAppSelector } from 'store/hooks';
import RouteLeaving from './RouteLeaving';

export default () => {
  const routeLeavingConfigs = useAppSelector(selectRouteLeavingConfigs);

  return <RouteLeaving routeLeavingConfigs={routeLeavingConfigs} />;
};
